import { render, staticRenderFns } from "./StaticMotion.vue?vue&type=template&id=b7b71fd0"
import script from "./StaticMotion.vue?vue&type=script&lang=js"
export * from "./StaticMotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports